
import React, { useState } from "react";
import ReferralCreated from "./ReferralCreated";
import ReferralUsed from "./ReferralUsed";
import ReferralStats from "./ReferralStats";

const Referral = () => {
  const [activeComponent, setActiveComponent] = useState(
    localStorage.getItem("ReferralTab") || "Referral Stats"
  );

  const tabs = [
    { name: "Referral Stats", component: <ReferralStats /> },
    { name: "Created Referrals", component: <ReferralCreated /> },
    { name: "Used Referrals", component: <ReferralUsed /> },
  ];

  const renderComponent = () => {
    const activeTab = tabs.find((tab) => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeTab = (name) => {
    setActiveComponent(name);
    localStorage.setItem("ReferralTab", name);
  };

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col items-center w-full sticky top-14 bg-[var(--bgColor)] z-10">
        <h1 className="text-xl m-4 font-semibold">Referral History</h1>

        <div className="flex gap-2 flex-wrap mb-2">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`p-2 rounded-lg text-sm border-b-2 min-w-[120px] ${
                activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
              }`}
              onClick={() => changeTab(name)}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default Referral;